import { Card } from "antd";
import React, { useEffect, useState } from "react";
import { TransformVcbConsumptionToStackedBar } from "../chartdata.transformers";
import { APIConstants } from "../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
  import dayjs from "dayjs";
import { getAdjustedDate } from "../CommonFunctions";
import { adjustTimeByFiveHoursThirtyMinutes } from "../../../Utils/DateConverstion";


const Table1 = (props) => {
  const theme = props.theme;
  const correctDate = new Date(getAdjustedDate());
  const [data, setData] = useState([]); 
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [loading, setLoading] = useState(true);
  const [toDate, setToDate] = useState(dayjs(correctDate).hour(6).minute(0).second(0));
  // const [fromDate, setFromDate] = useState(dayjs(correctDate)
  // .subtract(7, "days")
  // .hour(6)
  // .minute(0)
  // .second(0));
  const [fromDate, setFromDate] = useState(() =>
    dayjs().startOf("month").hour(6).minute(0).second(0)
  );
  const formatDateForURL = (dateString) => {
    const date = new Date(dateString);
    date.setMilliseconds(0); // Remove milliseconds
  
    let isoString = date.toISOString().split(".")[0]; // Remove milliseconds part
    return encodeURIComponent(isoString.replace("T", " "));
  };
      const getReposnse = async () => {
        // setLoading(true)
        const currentDate = new Date();
    
        // const { from, to } = calculateDateRangeFromDate(currentDate, 1, 1);
        console.log(fromDate)
    
        const inputData = {
          FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
          ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
        };
        console.log("getReposnse");
        console.log(inputData.ToDate, inputData.FromDate);
        try {
          const res = await makeRequest({
            type: APIConstants.GET,
            // url: `${APIConstants.LUCAS_SF6VCB_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
            url: `${APIConstants.ELECTRICAL_MTD_CONSUMPTION}?FromDate=${formatDateForURL(inputData.FromDate)}&ToDate=${formatDateForURL(inputData.ToDate)}`,
          });
          console.log(res)
          const response  = res.map(({ groupName, groupConsumption }) => ({
            name: groupName === "MAIN EB INCOMER" ? "EB" : groupName === "TotalConsumption" ? "Total" : groupName,
            groupConsumption,
          }));
          console.log(response)
          // console.log(TransformVcbConsumptionToStackedBar(res));
          // const response = TransformVcbConsumptionToStackedBar(res);
          setData(response);
        } catch (error) {
          console.log(error); 
        } finally {
          setLoading(false); // Stop loading
        }

      };
    
      console.log(data);
    
      useEffect(() => {
        getReposnse();
      }, []);
  return (


    // <div className="flex justify-between items-start w-full border border-gray-500 rounded-lg  ">
    // <div className="flex flex-col w-[32%] border-r-2 border-gray-500 ">
    //   <div className=" p-2 px-6  text-black text-lg">
    //     Electrical MTD Consumption
    //   </div>
    //     <div className="text-gray-700 text-sm  space-y-1 p-3 pt-0">
    //       <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2">
    //         <strong>EB</strong>
    //         <p>:</p>
    //         <p> 46,250.00</p>
    //       </div>
    //       <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2">
    //         <strong>DG</strong>
    //         <p>:</p>
    //         <p> 46,250.00</p>
    //       </div>
    //       <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2">
    //         <strong>Solar</strong>
    //         <p>:</p>
    //         <p> 46,250.00</p>
    //       </div>
    //       <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2">
    //         <strong>Total</strong>
    //         <p>:</p>
    //         <p> 46,250.00</p>
    //       </div>
    //     </div>
    // </div>
    // <div className="flex flex-col w-[32%] border-r-2 border-gray-500 ">
    //   <div className=" p-2 px-6  text-black text-lg">
    //   Compressed Air Consumption
    //   </div>
    //     <div className="text-gray-700 text-sm  space-y-1 p-3 pt-0">
    //       <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2">
    //         <strong>Yesterday</strong>
    //         <p>:</p>
    //         <p> 46,250.00</p>
    //       </div>
    //       <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2">
    //         <strong>MTD</strong>
    //         <p>:</p>
    //         <p> 46,250.00</p>
    //       </div>
    //     </div>
    // </div>
    // <div className="flex flex-col w-[32%]  ">
    //   <div className=" p-2 px-6  text-black text-lg">
    //   Total Scope-2 Co2 Emissions
    //   </div>
    //     <div className="text-gray-700 text-sm  space-y-1 p-3 pt-0">
    //       <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2">
    //         <strong>Today</strong>
    //         <p>:</p>
    //         <p> 46,250.00</p>
    //       </div>
    //       <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2">
    //         <strong>Month (to Date)</strong>
    //         <p>:</p>
    //         <p> 46,250.00</p>
    //       </div>
    //       <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2">
    //         <strong>Year (to Date)</strong>
    //         <p>:</p>
    //         <p> 46,250.00</p>
    //       </div>
    //     </div>
    // </div>

    // </div>
    <div className={`${
      theme === "dark" ? "bg-transparent text-white" : "bg-white "
    }  flex justify-between items-start w-full border rounded-lg p-2  shadow-md`}>
    <div className="flex flex-col w-[32%] border-r-[1px]  pr-4">
      <div className="p-2 px-4  text-lg">Electrical MTD Consumption</div>
      <div className="text-gray-700 text-sm space-y-1 p-3 pt-0">
        {data.map((i)=>(
          <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2"><strong>{i.name}</strong><p>:</p><p>{i.groupConsumption}</p></div>
        ))}
        {/* <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2"><strong>DG</strong><p>:</p><p> 46,250.00</p></div>
        <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2"><strong>Solar</strong><p>:</p><p> 46,250.00</p></div>
        <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2"><strong>Total</strong><p>:</p><p> 46,250.00</p></div> */}
      </div>
    </div>
    <div className="flex flex-col w-[32%]  pr-4">
      <div className="p-2 px-4  text-lg">Compressed Air Consumption</div>
      <div className="text-gray-700 text-sm space-y-1 p-3 pt-0">
        <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2"><strong>Yesterday</strong><p>:</p><p> 0</p></div>
        <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2"><strong>MTD</strong><p>:</p><p> 0</p></div>
      </div>
    </div>
    <div className="flex flex-col w-[32%] border-l-[1px] h-[230px] ">
      <div className="p-2 px-4  text-lg">Total Scope-2 Co2 Emissions</div>
      <div className="text-gray-700 text-sm space-y-1 p-3 pt-0">
        <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2"><strong>Today</strong><p>:</p><p> 0</p></div>
        <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2"><strong>Month (to Date)</strong><p>:</p><p> 0</p></div>
        <div className="grid grid-cols-3 bg-blue-100 rounded-lg px-3 pt-2"><strong>Year (to Date)</strong><p>:</p><p> 0</p></div>
      </div>
    </div>
  </div>
  );
};

export default Table1;
